import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SelectFilterModule} from "../../../../../components/common/select-filter/select-filter.module";
import {ProductSelectFilterComponent} from "./product-select-filter.component";
import {ProductSaveModalModule} from "../product-save-modal/product-save-modal.module";
import {
    MultipleSelectFilterModule
} from '../../../../core/component/multiple-select-filter/multiple-select-filter.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule,
        ProductSaveModalModule,
        MultipleSelectFilterModule
    ],
    declarations: [
        ProductSelectFilterComponent
    ],
    exports: [
        ProductSelectFilterComponent
    ]
})
export class ProductSelectFilterModule {
}
